import { gql } from '@apollo/client'

export default gql(`
mutation createFile($key:String! $name: String $tags: [ID] $project: String $type: String! $mediaType: String){
    createFile(
        input:{
            key:$key
            type:$type
            name:$name
            tags: $tags
            project: $project
            mediaType:$mediaType
        }
    ){
        id
        fileName
        createdAt
        name
        type
        fileSize
        duration
        thumbnails
        tags{
            key
            name
            type
        }
        category{
            id
            label
            type
        }
        settings {
            aspectRatio
            outputFormat
            fileName
            x1
            y1
            x2
            y2
        }
        dimensions{
            x1
            x2
            y1
            y2
        }
        aspectRatio {
            aspectRatio
            ratio
            title
            resolutions {
            key
            width
            height
            url
            }
        }
        drmContent
        streams{
            id
            drm
            codec
            Url
            iv
            transport
            contentKey
        }
        vodStatus{
            id
            startTime
            endTime
            channel{
                id
                icon{
                    id
                    fileName
                    aspectRatio {
                        aspectRatio
                        ratio
                        title          
                        resolutions {
                        url
                        }
                    }
                    settings {
                        aspectRatio
                        outputFormat
                        fileName
                        x1
                        y1
                        x2
                        y2
                    }
                }
            }
        }
    }
    }
`)
